import { gql } from "@apollo/client";

import { ChatSessionMessageReactionFragment } from "./get-ask-ai-session-query";

export default gql`
  ${ChatSessionMessageReactionFragment}
  mutation createChatMessageReaction(
    $messageId: String!
    $reactionType: ChatSessionReactionType!
    $chatSessionId: Int!
  ) {
    createChatbotMessageReaction(
      messageId: $messageId
      reactionType: $reactionType
      chatSessionId: $chatSessionId
    ) {
      chatSession {
        id
        updated
        reactions {
          edges {
            node {
              id
            }
          }
        }
      }
      reaction {
        ...ChatSessionMessageReactionFragment
      }
    }
  }
`;
